/**
 * AudioManager - Centralized audio control
 * Ensures only one audio plays at a time and stops audio on navigation
 */

class AudioManager {
  constructor() {
    this.activeAudios = new Set();
  }
  
  // Register audio element for tracking
  register(audio, id = null) {
    const audioId = id || `audio_${Date.now()}_${Math.random()}`;
    this.activeAudios.add({ audio, id: audioId });
    
    // Auto-unregister when audio ends naturally
    audio.addEventListener('ended', () => {
      this.unregister(audioId);
    });
    
    console.log('🔊 Audio registered:', audioId, 'Total active:', this.activeAudios.size);
    return audioId;
  }
  
  // Unregister specific audio
  unregister(audioId) {
    for (const item of this.activeAudios) {
      if (item.id === audioId) {
        this.activeAudios.delete(item);
        console.log('🔇 Audio unregistered:', audioId);
        break;
      }
    }
  }
  
  // Stop all active audio (on navigation or new audio start)
  stopAll() {
    console.log('🛑 Stopping all audio. Active count:', this.activeAudios.size);
    
    for (const { audio, id } of this.activeAudios) {
      try {
        if (audio && !audio.paused) {
          audio.pause();
          audio.currentTime = 0;
          console.log('🛑 Stopped audio:', id);
        }
      } catch (error) {
        console.warn('⚠️ Error stopping audio:', id, error);
      }
    }
    
    this.activeAudios.clear();
  }
  
  // Check if any audio is playing
  isAnyPlaying() {
    for (const { audio } of this.activeAudios) {
      if (audio && !audio.paused) {
        return true;
      }
    }
    return false;
  }
}

// Export singleton
export const audioManager = new AudioManager();

